export default __webpack_public_path__ + "static/media/cake23.30ded603.jpeg";